import { REGIONS, BLOGGING_SECTIONS } from 'shared/constants';

const defaultProps = require('./default-props');

const slots = [
  {
    slotId: 'menu-bar',
    label: 'Menu bar'
  },
  {
    slotId: 'footer',
    label: 'Footer area'
  }
];

const templateSettings = [
  {
    type: 'ENUM',
    key: 'region',
    label: 'Region',
    options: REGIONS
  },
  {
    type: 'ENUM',
    key: 'section',
    label: 'Section',
    options: BLOGGING_SECTIONS
  },
  {
    type: 'STRING',
    key: 'tag',
    label: 'Tag',
  },
  {
    type: 'STRING',
    key: 'page_title',
    label: 'Page Title',
  }
];

export default {
  id: 'FutureSightTag',
  name: 'FutureSight Tag',
  creator: 'FF Web',
  updatedBy: 'Claire Lin',
  createdAt: 1503956140000,
  updatedAt: 1503956140000,
  slots,
  templateSettings,
  defaultProps
};
